module.exports = __webpack_public_path__ + "static/img/btn_left.58d72a20.png";